<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>THÔNG TIN THÊM</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pb-6 pt-0">
        <v-form v-bind="this.$attrs">
          <div>
            <div v-for="(student, index) in students" :key="index">
              <div class="px-0 pt-6">
                <div class="d-flex">
                  <div class="pb-6 d-flex" style="flex-grow: 1;">
                    <v-text-field
                      :label="`Tên học sinh ${index + 1}`"
                      v-model="student.name"
                      outlined
                      hide-details
                      style="flex-grow: 1;"
                      class="pr-6"
                    ></v-text-field>
                    <v-text-field
                      label="Trường"
                      v-model="student.school"
                      outlined
                      hide-details
                      style="flex-grow: 1;"
                      class="pr-6"
                    ></v-text-field>
                  </div>
                  <div class="pb-6 d-flex align-items-center justify-content-end" style="flex-grow: 0;">
                    <v-icon @click="removeStudent(index)" color="transparent">mdi-trash-can</v-icon>
                  </div>
                </div>

                <div class="d-flex">
                  <div class="pb-6 d-flex" style="flex-grow: 1;">
                    <v-text-field
                      label="Ngày sinh (dd/mm/yyyy)"
                      v-model="student.dob"
                      mask="##/##/####"
                      return-masked-value
                      outlined
                      hide-details
                      style="flex-grow: 1;"
                      class="pr-6"
                    ></v-text-field>
                    <v-text-field
                      label="Lớp đang học"
                      v-model="student.class"
                      outlined
                      hide-details
                      style="flex-grow: 1;"
                      class="pr-6"
                    ></v-text-field>
                  </div>
                  <div class="pb-6 d-flex align-items-center justify-content-end" style="flex-grow: 0;">
                    <v-icon @click="removeStudent(index)">mdi-trash-can</v-icon>
                  </div>
                </div>
              </div>

              <v-divider v-if="index < students.length - 1"></v-divider>
            </div>
            <div class="d-flex justify-space-between">
              <v-spacer></v-spacer>
              <v-btn outlined color="blue darken-4" @click="addStudent">Thêm</v-btn>
            </div>
          </div>
        </v-form>
      </v-card-text>

      <v-divider> </v-divider>
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import utils from '@/plugins/utils'
import {mapActions, mapGetters} from 'vuex'
export default {
  props: {
    state: Boolean,
    profile: Object
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    },
    profile: {
      immediate: true,
      handler(newProfile) {
        if (newProfile) {
          this.setFormValues(newProfile)
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      dialog: false,
      loading: false,
      students: [
        {
          name: '',
          class: '',
          dob: '',
          school: ''
        }
      ]
    }
  },
  methods: {
    ...mapActions('lead', ['updateLead']),

    close() {
      this.$emit('closeDialog')
    },
    addStudent() {
      this.students.push({
        name: '',
        class: '',
        dob: '',
        school: ''
      })
    },
    removeStudent(index) {
      if (this.students.length <= 1) {
        this.$set(this.students, 0, {
          name: '',
          class: '',
          dob: '',
          school: ''
        })
      } else {
        this.students.splice(index, 1)
      }
    },

    async submit() {
      this.$loading.active = true

      const filteredStudents = this.students.filter(student => {
        return student.name !== '' || student.dob !== '' || student.class !== '' || student.school !== ''
      })

      let lead = {data: {student: filteredStudents}}

      const processField = field => {
        return filteredStudents
          .map(student => student[field])
          .filter(Boolean)
          .map(name => utils.removeUnicode(name).toLowerCase())
          .join(' // ')
      }

      lead.createdByName = this.user.name
      lead.studentNameSearchField = processField('name')
      lead.studentSchoolSearchField = processField('school')
      lead.studentClassSearchField = processField('class')

      const updatedLead = await this.updateLead({id: this.profile.id, ...lead})

      if (updatedLead) {
        this.$emit('refresh')
        this.close()
      }
    },
    setFormValues(profile) {
      if (profile.data && profile.data.student && profile.data.student.length > 0) {
        this.students = profile.data.student
      } else {
        this.students = [
          {
            name: '',
            class: '',
            dob: '',
            school: ''
          }
        ]
      }
    }
  }
}
</script>
